namespace TWOFA {
  export enum TYPES {
    SIGN_IN = 'sign_in',
    CHARGE_TENANT_MANUALLY = 'charge_tenant_manually',
    SA_ALLOWED_IP = 'sa_allowed_ip',
  }
}

export default TWOFA;
